import React from "react";

import  DemandeIndex from "../../../components/demande/DemandeIndex";

const SaisiIndex = ({serverOffline}) => {
      return  <DemandeIndex titre="Saisie d'index" userId={localStorage.getItem("userId")} serverOffline = {serverOffline}/>
};

export default SaisiIndex;
